var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-center"},[_c('b-icon-code-slash',{staticClass:"text-muted",attrs:{"font-scale":"2"}}),_vm._v(" thisdudecodes.com"),_c('br'),_vm._v("© "+_vm._s(this.year.getFullYear()))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }